/* let confettiTimer = null;
const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

function fireConfetti() {
  if (typeof confetti === 'undefined') {
    return;
  }
  confetti({
    angle: -90, // 紙吹雪が飛ぶ方向（指定しないと90＝上向き）90
    spread: isMobile ? 150 : 400,
    startVelocity: isMobile ? 30 : 40, // 紙吹雪が上に飛ぶ速度20
    scalar: 1, // 紙吹雪の大きさ2
    gravity: 1, // 重力 （0にすると紙吹雪が落ちない）1
    origin: {
      x: Math.round(Math.random() * 100) / 100,
      y: -0.5,
    },
    particleCount: isMobile ? 30 : 50, //100
    ticks: isMobile ? 400 : 600, //1000
  });
  confettiTimer = setTimeout(fireConfetti, isMobile ? 2000 : 1500);
}

// タブ非表示時は停止
document.addEventListener('visibilitychange', () => {
  if (document.hidden) {
    clearTimeout(confettiTimer);
    confettiTimer = null;
  } else {
    fireConfetti();
  }
});

function initConfetti() {
  if (typeof confetti !== 'undefined') {
    fireConfetti();
  } else {
    setTimeout(initConfetti, 100);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initConfetti);
} else {
  initConfetti();
}
 */

document.addEventListener('DOMContentLoaded', function () {
  const STORAGE_KEY = 'cmPopupLastShownDate';

  // YYYY-MM-DD（ローカル時間）
  const getTodayStr = () => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  };

  const todayStr = getTodayStr();

  let lastShownDate = null;
  try {
    lastShownDate = localStorage.getItem(STORAGE_KEY);
  } catch (e) {
    // localStorage が使えない場合は毎回表示
  }

  // 今日すでにポップアップを閉じていたら紙吹雪は出さない
  if (lastShownDate === todayStr) return;

  const particles = document.getElementById('particles-js');
  if (!particles) return;

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  particlesJS('particles-js', {
    particles: {
      number: {
        value: isMobile ? 10 : 8,
        density: {
          enable: true,
          value_area: isMobile ? 400 : 600,
        },
      },
      color: {
        value: ['#EA5532', '#F6AD3C', '#FFF33F', '#00A95F', '#00ADA9', '#00AFEC', '#4D4398', '#E85298'],
      },
      shape: {
        type: 'polygon',
        stroke: {width: 0},
        polygon: {nb_sides: 4},
      },
      opacity: {
        value: 1,
        random: true,
      },
      size: {
        value: 8,
        random: false,
        anim: {
          enable: true,
          speed: 4,
          size_min: 4,
          sync: false,
        },
      },
      line_linked: {
        enable: false,
      },
      move: {
        enable: true,
        speed: isMobile ? 6 : 8,
        direction: 'bottom',
        random: true,
        straight: false,
        out_mode: 'out',
        bounce: false,
      },
    },
    interactivity: {
      detect_on: 'canvas',
      events: {
        onhover: {enable: false},
        onclick: {enable: false},
        resize: true,
      },
    },
    retina_detect: false,
  });
});
